import { ref } from '#imports';

export function useNavigationToCards(navigationItems) {
  const activeLinkId = ref(navigationItems[0]?.id);
  const showNavigation = ref(false);

  function scrollToElement(elementId) {
    activeLinkId.value = elementId;
    showNavigation.value = false;
    const element = document.getElementById(elementId);
    element.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  return { scrollToElement, activeLinkId, showNavigation };
}
